/**
 * Downloads a gift code PDF from its signed URL, in place. The URL carries
 * `Content-Disposition: attachment`, so following it saves the file without
 * leaving the page or opening a tab.
 */
export function downloadGiftCodePdf(url: string) {
  const link = document.createElement("a");
  link.href = url;
  link.rel = "noopener";
  document.body.appendChild(link);
  link.click();
  link.remove();
}
